export * from './common/common'
export * from './common/form'
export * from './personalCenter/bankcardList'
export * from './common/fileUpload'
export * from './common/modal'
export * from './index'
export * from './products/products'
export * from './products/productDetails'
export * from './user/user'
export * from './personalCenter/myInfo'
export * from './personalCenter/repaymentInfo'
export * from './personalCenter/wholeRepay'
export * from './personalCenter/realNameAuth'



// WEBPACK FOOTER //
// ./src/vuex/types/type.js